'use client'

import { useState, useEffect } from 'react';

export default function SongLyric({ song }) {
  const lyrics = song.lyrics ? song.lyrics.split('\n').map((lyric: string) => lyric.split(']')[1]).filter((lyric: string) => lyric) : []
  /* const lyricsInit = lyrics.slice(0, 20)
  const [lyricsMore, setLyricsMore] = useState([])

  useEffect(() => {
    setLyricsMore(lyrics.slice(20))
  }, []) */

  return lyrics.length ? (
    <section className="section-similars px-6 pb-6" data-song-id={song?.id}>
      <h2 className="-ml-1 mb-1 text-[22px]">Lyric</h2>
      {/* <article className="-ml-1 opacity-80">
        {
          lyricsInit.map((lyric: string, index: number) => <p key={index}>{lyric}</p>)
        }

        {
          lyricsMore?.length ? lyricsMore.map((lyric: string, index: number) => <p key={index}>{lyric}</p>) : null
        }
      </article> */}
      <article className="-ml-1 mt-4 opacity-80">
        {
          lyrics.map((lyric: string, index: number) => <p key={index}>{lyric}</p>)
        }
      </article>
    </section>
  ) : null
}
